import React, { useRef } from 'react';
import { TieredMenu } from 'primereact/tieredmenu';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const TieredMenuButton = ({ btnColor = 'white', icon = 'ellipsis', iconColor = '#000', menuModel, modelProps = {}, buttonClass = '', style = {}}) => {
  const menuRef = useRef(null);

  return (
    <>
      <button
        type="button"
        className={`btn btn-default bg-${btnColor} btn-circle btn-my ${buttonClass}`}
        style={{ margin: '0px 2px 2px 2px', ...style }}
        onClick={(e) => menuRef.current.toggle(e)}
      >
        <i className={`fa fa-${icon} fa-fw img-circle`} style={{ color: iconColor }}></i>
      </button>

      <TieredMenu model={menuModel(modelProps)} popup ref={menuRef} />
    </>
  );
};

export default TieredMenuButton;
